import { createStore, type StoreApi } from 'zustand';

/**
 * @internal
 */
export type AppStateStore = {
  data: Record<string, string>;
  isLoading: boolean;
  error: Error | null;
  fetchedKeys: ReadonlySet<string>;
  keyErrors: Record<string, Error>;
  deletingKeys: ReadonlySet<string>;
  onError?: (error: Error) => void;
};

/**
 * @internal
 */
export function createAppStateStore(): StoreApi<AppStateStore> {
  return createStore<AppStateStore>(() => ({
    data: {},
    isLoading: true,
    error: null,
    fetchedKeys: new Set(),
    keyErrors: {},
    deletingKeys: new Set(),
  }));
}
